import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Grid,
  GridItem,
  Card,
  CardHeader,
  CardBody,
  HStack,
  Badge,
  Divider,
  SimpleGrid,
  Collapse,
  IconButton,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  List,
  ListItem,
  Textarea,
  Select,
  Checkbox
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon, RepeatIcon, ChatIcon } from '@chakra-ui/icons';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './Overzicht.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';
import colors from '../../../theme/colors';

// API URL from environment variable with fallback to localhost
const API_URL = process.env.REACT_APP_API_URL || '';

class Overzicht extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      showCustomSummaryForm: false,
      customInstructions: '',
      summaryLength: 'medium',
      includeExamples: true,
      generatingCustomSummary: false,
      customSummaryResult: null,
      savingSummary: false
    };
  }
  
  componentDidMount() {
    // Load summaries and trending topics when component mounts
    if (this.props.loadSummaries) {
      this.props.loadSummaries();
    }
    if (this.props.loadTrendingTopics) {
      this.props.loadTrendingTopics();
    }
    if (this.props.loadProblems) {
      this.props.loadProblems();
    }
  }

  toggleCustomSummaryForm = () => {
    this.setState({
      showCustomSummaryForm: !this.state.showCustomSummaryForm,
      customInstructions: '',
      summaryLength: 'medium',
      includeExamples: true,
      customSummaryResult: null
    });
  }

  handleInstructionsChange = (e) => {
    this.setState({ customInstructions: e.target.value });
  }

  handleLengthChange = (value) => {
    this.setState({ summaryLength: value });
  }

  handleExamplesToggle = (e) => {
    this.setState({ includeExamples: e.target.checked });
  }

  generateCustomSummary = async () => {
    if (!this.state.customInstructions.trim()) {
      this.props.toast({
        title: 'Fout',
        description: 'Voer instructies in voor de samenvatting',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    this.setState({ generatingCustomSummary: true });

    try {
      let response = await this.props.authenticatedFetch(`${API_URL}/generate_custom_summary`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          instructions: this.state.customInstructions,
          summaryLength: this.state.summaryLength,
          includeExamples: this.state.includeExamples
        })
      });

      let result = await response.json();
      
      if (result.success) {
        this.setState({ 
          customSummaryResult: result.result,
          generatingCustomSummary: false
        });
        this.props.toast({
          title: 'Succes',
          description: 'Aangepaste samenvatting gegenereerd!',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error(result.message || 'Fout bij genereren samenvatting');
      }
    } catch (error) {
      console.error('Error generating custom summary:', error);
      this.setState({ generatingCustomSummary: false });
      this.props.toast({
        title: 'Fout',
        description: error.message || 'Er ging iets mis bij het genereren van de samenvatting',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  }

  saveSummary = async () => {
    if (!this.state.customSummaryResult) {
      return;
    }

    this.setState({ savingSummary: true });

    try {
      let response = await this.props.authenticatedFetch(`${API_URL}/save_custom_summary`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          instructions: this.state.customInstructions,
          summary: this.state.customSummaryResult
        })
      });

      let result = await response.json();
      
      if (result.success) {
        this.setState({ 
          savingSummary: false,
          customSummaryResult: null,
          customInstructions: '',
          showCustomSummaryForm: false
        });
        this.props.toast({
          title: 'Succes',
          description: 'Samenvatting opgeslagen als kaart!',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        
        if (this.props.loadSummaries) {
          this.props.loadSummaries();
        }
      } else {
        throw new Error(result.message || 'Fout bij opslaan samenvatting');
      }
    } catch (error) {
      console.error('Error saving summary:', error);
      this.setState({ savingSummary: false });
      this.props.toast({
        title: 'Fout',
        description: error.message || 'Er ging iets mis bij het opslaan van de samenvatting',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }

  render () {
    const summaries = this.props.state.summaries || { items: [], loading: false, lastUpdated: null };
    const trendingTopics = this.props.state.trendingTopics || { items: [], loading: false, lastUpdated: null };
    const problems = this.props.state.problems || { items: [], loading: false, lastUpdated: null };

    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
        {/* sidebar */}
        <GridItem
          as="aside"
          colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
          bg="gray.50"
          minHeight={{ lg: '100vh' }}
          p={0}
        >
        <Sidebar
        state = {this.props.state}
        getFeed = {this.props.getFeed}
        onRouteChange = {this.props.onRouteChange}
        userVersion = {this.props.state.userVersion}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p={{ base: "8px", md: "10px" }}
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p={{ base: "16px", md: "40px" }} flex="1">
          <VStack spacing={6} align="stretch">
            <Box textAlign="center">
              <Heading as="h2" size={{ base: "md", md: "lg" }} color="gray.600" mb={2}>
                Analyse-Overzicht
              </Heading>
              <Text color="gray.500" fontSize={{ base: "sm", md: "md" }} mb={4}>
                Analyse van veelvoorkomende thema's
              </Text>
              
              <VStack spacing={3} mb={6}>
                <Button
                  leftIcon={<RepeatIcon />}
                  size={{ base: "sm", md: "md" }}
                  onClick={this.props.generateSummaries}
                  isLoading={summaries.loading}
                  loadingText="Genereren..."
                  bg={colors.primary.main}
                  color="white"
                  _hover={{ bg: colors.primary.dark }}
                >
                  Ververs Overzicht
                </Button>
                {summaries.lastUpdated && (
                  <Text fontSize={{ base: "xs", md: "sm" }} color="gray.400" textAlign="center">
                    Laatst bijgewerkt: {new Date(summaries.lastUpdated).toLocaleString('nl-NL', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </Text>
                )}
              </VStack>
            </Box>
            
            {/* Trending Topics Section */}
            <Box mb={8}>
              <Heading as="h3" size={{ base: "sm", md: "md" }} color="gray.600" mb={4}>
                📈 Thema's
              </Heading>
              <Text color="gray.500" fontSize={{ base: "xs", md: "sm" }} mb={4}>
                Meest besproken onderwerpen op basis van keyword-matching (non-serieuze suggesties gefilterd)
              </Text>
              
              {trendingTopics.items && trendingTopics.items.length > 0 ? (
                <VStack spacing={3} align="stretch">
                  {trendingTopics.items.map((topic, index) => (
                    <TrendingTopicCard
                      key={index}
                      topic={topic}
                      rank={index + 1}
                      onTrendingTopicFilter={this.props.onTrendingTopicFilter}
                      csrfToken={this.props.state.csrfToken}
                      showToast={this.props.showToast}
                      authenticatedFetch={this.props.authenticatedFetch}
                    />
                  ))}
                </VStack>
              ) : (
                <Alert status="info" borderRadius="md" bg="gray.50" borderLeft="4px solid" borderColor="gray.400">
                  <AlertIcon color="gray.500" />
                  <Box>
                    <AlertTitle color="gray.700">Nog geen trending topics</AlertTitle>
                    <AlertDescription color="gray.600">
                      Er zijn nog niet genoeg suggesties om trending onderwerpen te identificeren.
                    </AlertDescription>
                  </Box>
                </Alert>
              )}
              
              {trendingTopics.lastUpdated && (
                <Text fontSize="xs" color="gray.400" mt={3} textAlign="center">
                  Laatst bijgewerkt: {new Date(trendingTopics.lastUpdated).toLocaleString('nl-NL')}
                </Text>
              )}
            </Box>

            <Divider my={8} />

            {/* Problemen Section */}
            <Box mb={8}>
              <Heading as="h3" size={{ base: "sm", md: "md" }} color="gray.600" mb={4}>
                🎯 Problemen
              </Heading>
              <Text color="gray.500" fontSize={{ base: "xs", md: "sm" }} mb={4}>
                Onderliggende problemen, samengevoegd door AI en gewogen naar hoeveel inwoners erover klagen
              </Text>

              <Button
                leftIcon={<RepeatIcon />}
                size={{ base: "sm", md: "md" }}
                onClick={this.props.refreshProblems}
                isLoading={problems.loading}
                loadingText="Analyseren..."
                bg={colors.primary.main}
                color="white"
                _hover={{ bg: colors.primary.dark }}
                mb={4}
              >
                Analyseer Problemen
              </Button>

              {problems.loading ? (
                <Box textAlign="center" py={8}>
                  <Spinner size="lg" color={colors.primary.main} />
                  <Text mt={4} color="gray.500">Problemen analyseren...</Text>
                </Box>
              ) : problems.items && problems.items.length > 0 ? (
                <VStack spacing={3} align="stretch">
                  {problems.items.map((problem, index) => (
                    <ProblemCard
                      key={index}
                      problem={problem}
                      rank={index + 1}
                      onProblemSelect={this.props.onProblemSelect}
                    />
                  ))}
                </VStack>
              ) : (
                <Alert status="info" borderRadius="md" bg="gray.50" borderLeft="4px solid" borderColor="gray.400">
                  <AlertIcon color="gray.500" />
                  <Box>
                    <AlertTitle color="gray.700">Nog geen problemen</AlertTitle>
                    <AlertDescription color="gray.600">
                      Er zijn nog niet genoeg suggesties om onderliggende problemen te identificeren.
                    </AlertDescription>
                  </Box>
                </Alert>
              )}

              {problems.lastUpdated && (
                <Text fontSize="xs" color="gray.400" mt={3} textAlign="center">
                  Laatst bijgewerkt: {new Date(problems.lastUpdated).toLocaleString('nl-NL')}
                </Text>
              )}
            </Box>

            <Divider my={8} />

            {/* AI Summaries Section */}
            <Box>
              <Heading as="h3" size={{ base: "sm", md: "md" }} color="gray.600" mb={2} textAlign="center">
                AI-Gegenereerde Samenvattingen
              </Heading>
              <Text color="gray.500" fontSize={{ base: "xs", md: "sm" }} mb={4} textAlign="center">
                Uitgebreide thematische analyses van de input van inwoners
              </Text>
              
              <HStack justify="center" mb={4}>
                <Button
                  onClick={this.toggleCustomSummaryForm}
                  variant="primary"
                  size={{ base: "md", md: "lg" }}
                  fontWeight="bold"
                  px={{ base: 6, md: 8 }}
                >
                  Creëer samenvatting
                </Button>
              </HStack>
            </Box>
            
            {/* Custom Summary Creation Form */}
            <Collapse in={this.state.showCustomSummaryForm}>
              <Card mb={6} bg="white" shadow="lg" borderRadius="xl" border="1px solid" borderColor="gray.100">
                <CardHeader>
                  <Heading size="md" color="green.700">
                    Samenvatting Creëren
                  </Heading>
                  <Text fontSize="sm" color="green.600" mt={1}>
                    Geef specifieke instructies voor hoe de AI de suggesties moet samenvatten
                  </Text>
                </CardHeader>
                <CardBody pt={0}>
                  <VStack spacing={4} align="stretch">
                    <Box>
                      <Text fontSize="sm" color="gray.600" mb={2}>
                        Instructies voor de samenvatting:
                      </Text>
                      <Textarea
                        value={this.state.customInstructions}
                        onChange={this.handleInstructionsChange}
                        placeholder="Bijvoorbeeld: 'Maak een samenvatting met focus op verkeersveiligheid en prioriteer suggesties van ouders' of 'Analyseer welke problemen het vaakst voorkomen en geef concrete oplossingsrichtingen'"
                        rows={4}
                        bg="white"
                        borderColor="gray.300"
                        _focus={{
                          borderColor: "green.400",
                          boxShadow: "0 0 0 1px green.400"
                        }}
                      />
                    </Box>

                    {/* Summary Length Select */}
                    <Box>
                      <Text fontSize="sm" color="gray.600" mb={2}>
                        Lengte van samenvatting:
                      </Text>
                      <Select
                        value={this.state.summaryLength}
                        onChange={(e) => this.handleLengthChange(e.target.value)}
                        bg="white"
                        borderColor="gray.300"
                        _focus={{
                          borderColor: "green.400",
                          boxShadow: "0 0 0 1px green.400"
                        }}
                      >
                        <option value="short">Kort</option>
                        <option value="medium">Normaal</option>
                        <option value="detailed">Uitgebreid</option>
                      </Select>
                    </Box>

                    {/* Include Examples Checkbox */}
                    <Box>
                      <Checkbox
                        isChecked={this.state.includeExamples}
                        onChange={this.handleExamplesToggle}
                        colorScheme="green"
                      >
                        <Text fontSize="sm" color="gray.600">
                          Toon concrete voorbeelden van suggesties in de samenvatting
                        </Text>
                      </Checkbox>
                    </Box>

                    <HStack spacing={3}>
                      <Button
                        variant="primary"
                        onClick={this.generateCustomSummary}
                        isLoading={this.state.generatingCustomSummary}
                        loadingText="Samenvatting genereren..."
                        isDisabled={!this.state.customInstructions.trim()}
                        size="md"
                      >
                        Creëer samenvatting
                      </Button>
                      <Button
                        variant="ghost"
                        onClick={this.toggleCustomSummaryForm}
                        size="md"
                      >
                        Annuleren
                      </Button>
                    </HStack>
                  </VStack>
                </CardBody>
              </Card>
            </Collapse>
            
            {/* Custom Summary Result */}
            {this.state.customSummaryResult && (
              <Card mb={6} bg="white" shadow="lg" borderRadius="xl" border="1px solid" borderColor="gray.100">
                <CardHeader>
                  <HStack justify="space-between">
                    <VStack align="start" spacing={1}>
                      <Heading size="md" color="green.700">
                        Samenvatting
                      </Heading>
                      <Text fontSize="sm" color="green.600">
                        Gegenereerd op basis van jouw instructies
                      </Text>
                    </VStack>
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => this.setState({ customSummaryResult: null })}
                    >
                      ✕
                    </Button>
                  </HStack>
                </CardHeader>
                <CardBody pt={0}>
                  <Box
                    p={4}
                    bg="white"
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.200"
                    mb={4}
                    sx={{
                      '& h1, & h2, & h3': {
                        fontSize: 'lg',
                        fontWeight: 'bold',
                        mb: 3,
                        mt: 4,
                        color: 'gray.800',
                        '&:first-of-type': { mt: 0 }
                      },
                      '& p': { mb: 3, color: 'gray.700', lineHeight: '1.7' },
                      '& ul, & ol': { ml: 6, mb: 3 },
                      '& li': { mb: 1.5, color: 'gray.700' },
                      '& strong': { fontWeight: 'semibold', color: 'gray.800' },
                      '& em': { fontStyle: 'italic' },
                      '& hr': { my: 4, borderColor: 'gray.300' },
                      '& code': {
                        bg: 'gray.100',
                        px: 1,
                        py: 0.5,
                        borderRadius: 'sm',
                        fontSize: 'sm',
                        fontFamily: 'monospace'
                      }
                    }}
                  >
                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                      {this.state.customSummaryResult}
                    </ReactMarkdown>
                  </Box>
                  <HStack spacing={3} justify="center">
                    <Button
                      colorScheme="green"
                      onClick={this.saveSummary}
                      isLoading={this.state.savingSummary}
                      loadingText="Opslaan..."
                      size="md"
                      leftIcon={<Text>💾</Text>}
                    >
                      Samenvatting Opslaan
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => this.setState({ customSummaryResult: null })}
                      size="md"
                    >
                      Verwerpen
                    </Button>
                  </HStack>
                </CardBody>
              </Card>
            )}
            
            {summaries.loading ? (
              <Box textAlign="center" py={12}>
                <Spinner size="xl" color="blue.500" mb={4} />
                <Text color="gray.500">Samenvattingen genereren...</Text>
              </Box>
            ) : summaries.items && summaries.items.length > 0 ? (
              <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                {summaries.items.map((summary, index) => (
                  <SummaryCard 
                    key={summary.id || index} 
                    summary={summary}
                    onExpandDetails={this.props.onExpandSummaryDetails}
                    onSummarySelect={this.props.onSummarySelect}
                  />
                ))}
              </SimpleGrid>
            ) : (
              <Alert status="info" borderRadius="md" bg="gray.50" borderLeft="4px solid" borderColor="gray.400">
                <AlertIcon color="gray.500" />
                <Box>
                  <AlertTitle color="gray.700">Geen samenvattingen</AlertTitle>
                  <AlertDescription color="gray.600">
                    Er zijn nog geen samenvattingen gecreëerd
                  </AlertDescription>
                </Box>
              </Alert>
            )}
          </VStack>
        </Box>

        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>

        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }
}

class SummaryCard extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      showingSamples: false
    };
  }

  toggleExpanded = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  showSamples = () => {
    this.setState({ showingSamples: true });
    if (this.props.onExpandDetails && this.props.summary.id) {
      this.props.onExpandDetails(this.props.summary.id);
    }
  }

  render() {
    const { summary } = this.props;
    const { isExpanded, showingSamples } = this.state;
    
    const getCategoryColor = (title) => {
      const colors = {
        'Verkeer': 'orange',
        'Milieu': 'green', 
        'Onderwijs': 'blue',
        'Zorg': 'red',
        'Economie': 'purple',
        'Veiligheid': 'teal',
        'Services': 'gray',
        'Recreatie': 'pink'
      };
      
      const matchedCategory = Object.keys(colors).find(category => 
        title.toLowerCase().includes(category.toLowerCase())
      );
      
      return matchedCategory ? colors[matchedCategory] : 'blue';
    }
    
    return (
      <Card
        bg="white"
        shadow="lg"
        borderRadius="xl"
        border="1px solid"
        borderColor="gray.100"
        _hover={{ shadow: 'md', transform: 'translateY(-1px)', cursor: 'pointer' }}
        transition="all 0.2s ease"
        onClick={() => this.props.onSummarySelect && this.props.onSummarySelect(summary)}
      >
        <CardHeader pb={2}>
          <HStack justify="space-between" align="start">
            <VStack align="start" spacing={1}>
              <Heading size="md" color="gray.700">
                {summary.title}
              </Heading>
              <Badge
                bg={colors.lila.bg}
                color={colors.lila.text}
                variant="solid"
                fontSize="xs"
              >
                {summary.suggestion_count} suggestie{summary.suggestion_count !== 1 ? 's' : ''}
              </Badge>
            </VStack>
            <IconButton
              icon={isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={(e) => {
                e.stopPropagation();
                this.toggleExpanded();
              }}
              size="sm"
              variant="ghost"
              color="gray.400"
            />
          </HStack>
        </CardHeader>
        
        <CardBody pt={0}>
          <Box
            color="gray.600"
            fontSize="sm"
            mb={3}
            sx={{
              '& h1, & h2, & h3': { fontSize: 'sm', fontWeight: 'semibold', mb: 1, color: 'gray.700' },
              '& p': { mb: 2 },
              '& ul, & ol': { ml: 4, mb: 2 },
              '& li': { mb: 0.5 },
              '& strong': { fontWeight: 'semibold' },
              '& em': { fontStyle: 'italic' }
            }}
          >
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
              {summary.summary}
            </ReactMarkdown>
          </Box>
          <Text fontSize="xs" color="blue.500" fontStyle="italic" mb={2}>
            Klik voor gedetailleerd overzicht →
          </Text>
          
          <Collapse in={isExpanded}>
            <Divider mb={3} />
            <VStack align="stretch" spacing={3}>
              <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                Details:
              </Text>
              <Text fontSize="xs" color="gray.500">
                Gebaseerd op {summary.suggestion_count} ingediende suggesties
              </Text>
              
              {!showingSamples ? (
                <Button
                  size="sm"
                  variant="outline"
                  colorScheme={getCategoryColor(summary.title)}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.showSamples();
                  }}
                >
                  Toon voorbeelden
                </Button>
              ) : (
                <Box>
                  <Text fontSize="sm" fontWeight="semibold" color="gray.600" mb={2}>
                    Voorbeeld suggesties:
                  </Text>
                  {summary.sample_suggestions ? (
                    <List spacing={1} fontSize="xs">
                      {summary.sample_suggestions.map((sample, idx) => (
                        <ListItem key={idx} color="gray.600">
                          <Text fontSize="xs" color="gray.600">
                            • {sample}
                          </Text>
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Text fontSize="xs" color="gray.400" fontStyle="italic">
                      Voorbeelden worden geladen...
                    </Text>
                  )}
                </Box>
              )}
              
              <Text fontSize="xs" color="gray.400">
                Laatst bijgewerkt: {summary.updated_at ? 
                  new Date(summary.updated_at).toLocaleDateString('nl-NL') : 
                  'Onbekend'}
              </Text>
            </VStack>
          </Collapse>
        </CardBody>
      </Card>
    );
  }
}

class TrendingTopicCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showFeedbackForm: false,
      feedbackText: '',
      feedbackSubmitted: false,
      submittingFeedback: false,
      hasFeedback: false,
      checkingFeedback: false
    }
  }

  componentDidMount() {
    this.checkExistingFeedback()
  }

  componentDidUpdate(prevProps) {
    // Check feedback when topic changes or suggestion_ids change
    const prevIds = prevProps.topic.suggestion_ids || []
    const currentIds = this.props.topic.suggestion_ids || []
    const idsChanged = JSON.stringify(prevIds.sort()) !== JSON.stringify(currentIds.sort())

    if (prevProps.topic.topic !== this.props.topic.topic || idsChanged) {
      this.checkExistingFeedback()
    }
  }

  checkExistingFeedback = async () => {
    const { topic } = this.props

    this.setState({ checkingFeedback: true })

    try {
      const response = await this.props.authenticatedFetch(
        `${API_URL}/check_trending_feedback`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            topic_name: topic.topic,
            suggestion_ids: topic.suggestion_ids || []
          })
        }
      )

      const data = await response.json()

      if (data.success) {
        this.setState({
          hasFeedback: data.has_feedback,
          feedbackSubmitted: data.has_feedback
        })
      }
    } catch (error) {
      console.error('Error checking feedback:', error)
    } finally {
      this.setState({ checkingFeedback: false })
    }
  }

  handleFeedbackClick = () => {
    this.setState({ showFeedbackForm: !this.state.showFeedbackForm })
  }

  handleFeedbackChange = (e) => {
    this.setState({ feedbackText: e.target.value })
  }

  submitFeedback = async () => {
    const { topic } = this.props
    const { feedbackText } = this.state

    // Validation
    if (!feedbackText.trim()) {
      this.props.showToast({
        title: 'Feedback vereist',
        description: 'Voer alstublieft feedback tekst in.',
        status: 'warning',
        duration: 3000
      })
      return
    }

    if (feedbackText.trim().length < 10) {
      this.props.showToast({
        title: 'Feedback te kort',
        description: 'Feedback moet minimaal 10 karakters bevatten.',
        status: 'warning',
        duration: 3000
      })
      return
    }

    this.setState({ submittingFeedback: true })

    try {
      const response = await this.props.authenticatedFetch(
        `${API_URL}/submit_trending_feedback`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            topic_name: topic.topic,
            feedback_text: feedbackText,
            people_count: topic.people_count,
            suggestion_count: topic.suggestion_count,
            suggestion_ids: topic.suggestion_ids || []
          })
        }
      )

      const data = await response.json()

      if (data.success) {
        this.setState({
          feedbackSubmitted: true,
          hasFeedback: true,
          showFeedbackForm: false,
          feedbackText: ''
        })

        this.props.showToast({
          title: 'Feedback verzonden!',
          description: data.message,
          status: 'success',
          duration: 5000
        })
      } else {
        this.props.showToast({
          title: 'Fout',
          description: data.message,
          status: 'error',
          duration: 5000
        })
      }
    } catch (error) {
      console.error('Error submitting feedback:', error)
      this.props.showToast({
        title: 'Netwerkfout',
        description: 'Kon geen verbinding maken met de server.',
        status: 'error',
        duration: 5000
      })
    } finally {
      this.setState({ submittingFeedback: false })
    }
  }

  getPriorityColor = (level) => {
    switch(level) {
      case 'high': return 'red';
      case 'medium': return 'orange';
      case 'low': return 'green';
      default: return 'gray';
    }
  }
  
  getPriorityIcon = (level) => {
    switch(level) {
      case 'high': return '🚨';
      case 'medium': return '⚠️';
      case 'low': return '📝';
      default: return '📋';
    }
  }

  getPriorityText = (level) => {
    switch(level) {
      case 'high': return 'Hoog';
      case 'medium': return 'Midden';
      case 'low': return 'Laag';
      default: return level;
    }
  }

  render() {
    const { topic, rank } = this.props;
    
    return (
      <Card 
        bg="white" 
        shadow="sm"
        borderLeft="4px solid"
        borderLeftColor={`${this.getPriorityColor(topic.priority_level)}.400`}
        _hover={{ shadow: 'md', transform: 'translateY(-1px)' }}
        transition="all 0.2s ease"
      >
        <CardBody p={4}>
          <HStack spacing={4} align="start">
            {/* Rank badge */}
            <Badge
              bg={colors.rankBadge.bg}
              color={colors.rankBadge.text}
              variant="solid"
              borderRadius="full"
              minW="30px"
              h="30px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="sm"
              fontWeight="bold"
            >
              #{rank}
            </Badge>
            
            {/* Main content */}
            <VStack align="start" spacing={2} flex="1">
              <HStack spacing={3} wrap="wrap">
                <Heading size="sm" color="gray.700">
                  {this.getPriorityIcon(topic.priority_level)} {topic.topic}
                </Heading>
                <Badge
                  colorScheme={this.getPriorityColor(topic.priority_level)}
                  variant="outline"
                  fontSize="xs"
                  textTransform="uppercase"
                >
                  {this.getPriorityText(topic.priority_level)}
                </Badge>
              </HStack>
              
              <Text fontSize="sm" color="gray.600" lineHeight="1.5">
                {topic.summary}
              </Text>
              
              <HStack spacing={6} fontSize="xs" color="gray.500">
                <HStack>
                  <Text fontWeight="semibold">{topic.people_count}</Text>
                  <Text>{topic.people_count === 1 ? 'persoon' : 'personen'}</Text>
                </HStack>
                <HStack>
                  <Text fontWeight="semibold">{topic.suggestion_count}</Text>
                  <Text>{topic.suggestion_count === 1 ? 'suggestie' : 'suggesties'}</Text>
                </HStack>
              </HStack>
              
              {topic.sample_suggestions && topic.sample_suggestions.length > 0 && (
                <Box mt={2} p={3} bg="neutral.50" borderRadius="md" w="100%"
                     cursor="pointer"
                     _hover={{ bg: "gray.100", transform: "translateY(-1px)" }}
                     transition="all 0.2s ease"
                     onClick={() => this.props.onTrendingTopicFilter && this.props.onTrendingTopicFilter(topic)}
                >
                  <HStack justify="space-between" mb={2}>
                    <Text fontSize="xs" fontWeight="semibold" color="gray.600">
                      Voorbeelden:
                    </Text>
                    <Text fontSize="xs" color={colors.primary.main} fontWeight="semibold" whiteSpace="nowrap">
                      Klik om alle te bekijken →
                    </Text>
                  </HStack>
                  <List spacing={1}>
                    {topic.sample_suggestions.slice(0, 2).map((sample, idx) => (
                      <ListItem key={idx} fontSize="xs" color="gray.600">
                        <Text as="span" color="gray.400">•</Text> {sample}
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}

              {/* Feedback section */}
              <Box mt={3} pt={3} borderTop="1px solid" borderColor="gray.200" w="100%">
                {this.state.hasFeedback ? (
                  <Text fontSize="sm" color="green.600">
                    ✓ Feedback gegeven
                  </Text>
                ) : (
                  <>
                    {!this.state.showFeedbackForm && (
                      <Button
                        size="sm"
                        leftIcon={<ChatIcon />}
                        bg={colors.primary.main}
                        color="white"
                        _hover={{ bg: colors.primary.dark }}
                        onClick={this.handleFeedbackClick}
                        isDisabled={this.state.checkingFeedback}
                      >
                        Feedback geven
                      </Button>
                    )}

                    <Collapse in={this.state.showFeedbackForm} animateOpacity>
                      <Box mt={3}>
                        <Textarea
                          placeholder="Wat vind je van dit trending onderwerp? (bijv. 'Deze suggesties horen niet bij elkaar' of 'Categorie naam is onduidelijk')"
                          value={this.state.feedbackText}
                          onChange={this.handleFeedbackChange}
                          size="sm"
                          rows={4}
                          maxLength={1000}
                        />
                        <HStack mt={2} spacing={2}>
                          <Button
                            size="sm"
                            bg={colors.primary.main}
                            color="white"
                            _hover={{ bg: colors.primary.dark }}
                            onClick={this.submitFeedback}
                            isLoading={this.state.submittingFeedback}
                            isDisabled={!this.state.feedbackText.trim() || this.state.feedbackText.trim().length < 10}
                          >
                            Verstuur
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => this.setState({ showFeedbackForm: false, feedbackText: '' })}
                          >
                            Annuleren
                          </Button>
                          <Text fontSize="xs" color="gray.500" ml="auto">
                            {this.state.feedbackText.length}/1000
                          </Text>
                        </HStack>
                      </Box>
                    </Collapse>
                  </>
                )}
              </Box>
            </VStack>
          </HStack>
        </CardBody>
      </Card>
    );
  }
}

// Clickable card for an identified underlying problem
class ProblemCard extends Component {

  getPriorityColor = (level) => {
    switch(level) {
      case 'high': return 'red';
      case 'medium': return 'orange';
      case 'low': return 'green';
      default: return 'gray';
    }
  }

  getPriorityIcon = (level) => {
    switch(level) {
      case 'high': return '🚨';
      case 'medium': return '⚠️';
      case 'low': return '📝';
      default: return '📋';
    }
  }

  getPriorityText = (level) => {
    switch(level) {
      case 'high': return 'Hoog';
      case 'medium': return 'Midden';
      case 'low': return 'Laag';
      default: return level;
    }
  }

  truncateText = (text, maxLength = 140) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }

  render() {
    const { problem, rank } = this.props;

    return (
      <Card
        bg="neutral.50"
        shadow="sm"
        borderLeft="4px solid"
        borderLeftColor={`${this.getPriorityColor(problem.priority_level)}.400`}
        _hover={{ bg: 'blue.50', cursor: 'pointer', transform: 'translateY(-1px)' }}
        transition="all 0.2s ease"
        onClick={() => this.props.onProblemSelect && this.props.onProblemSelect(problem)}
      >
        <CardBody p={4}>
          <HStack spacing={4} align="start">
            <Badge
              bg={colors.rankBadge.bg}
              color={colors.rankBadge.text}
              variant="solid"
              borderRadius="full"
              minW="30px"
              h="30px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="sm"
              fontWeight="bold"
            >
              #{rank}
            </Badge>

            <VStack align="start" spacing={2} flex="1">
              <HStack spacing={3} flexWrap="wrap">
                <Heading size="sm" color="gray.700">
                  {this.getPriorityIcon(problem.priority_level)} {problem.title}
                </Heading>
                <Badge
                  colorScheme={this.getPriorityColor(problem.priority_level)}
                  variant="outline"
                  fontSize="xs"
                  textTransform="uppercase"
                >
                  Urgentie: {this.getPriorityText(problem.priority_level)}
                </Badge>
              </HStack>

              {problem.description && (
                <Text fontSize="sm" color="gray.600">
                  {this.truncateText(problem.description, 140)}
                </Text>
              )}

              <HStack spacing={4} fontSize="xs" color="gray.500">
                <Badge colorScheme="orange" variant="subtle">
                  Gewicht: {problem.weight}
                </Badge>
                <Text fontWeight="semibold">
                  {problem.weight} {problem.weight === 1 ? 'persoon' : 'personen'}
                </Text>
                <Text>•</Text>
                <Text fontWeight="semibold">
                  {problem.suggestion_count} {problem.suggestion_count === 1 ? 'suggestie' : 'suggesties'}
                </Text>
              </HStack>
            </VStack>
          </HStack>
        </CardBody>
      </Card>
    );
  }
}

export default Overzicht